import type { AiCreditTransaction } from '@ztechapps/common.contract'
import type { BodyRowConfig, DataTableProps } from '@ztechapps/webui.data-tools'
import { DataTable } from '@ztechapps/webui.data-tools'
import { EmptyContent } from '@ztechapps/webui.util'
import { ListRow } from './ListRow'
import { ListHeader } from './ListHeader'
import { Stats } from './Stats'
import { useUsageListContext } from './Context'

export type UsageListProps = {
  onRowDoubleClick?: (row: BodyRowConfig<AiCreditTransaction>) => void
  // A page that fills its region passes `{ topMargin }`, so the table body scrolls inside the table and
  // loads the next page; without it the table grows with its page and never loads past the first page.
  height?: DataTableProps<AiCreditTransaction>['height']
}

export const UsageList = ({ onRowDoubleClick, height }: UsageListProps) => {
  const { usageList, fields } = useUsageListContext()

  // DataTable never receives an `isEmpty` for its DataSuspense (DataTable/types.ts excludes it from
  // `dataSuspenseOptions`), so an empty result would render only the header and "Showing 0 of 0";
  // the message is composed here instead. An error keeps DataTable so its error content still shows.
  if (usageList.isEmpty && !usageList.error) return <EmptyContent message="No records available." />

  return (
    <DataTable
      fields={fields}
      listResult={usageList}
      row={ListRow}
      head={ListHeader}
      stats={<Stats />}
      tableOptions={{ responsive: true }}
      height={height}
      onRowDoubleClick={onRowDoubleClick}
    />
  )
}
